import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import useSalaryDoughnutData from './useSalaryDoughnutData';
import ChartGlassPanel from '../../components/ChartGlassPanel';

const COLORS = ['#2563eb', '#22c55e', '#f59e42', '#e11d48'];

export default function SalaryDoughnutChart() {
  const data = useSalaryDoughnutData();
  return (
    <ChartGlassPanel>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="component"
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={80}
              label
            >
              {data.map((entry, idx) => (
                <Cell key={`cell-${idx}`} fill={COLORS[idx % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </ChartGlassPanel>
  );
}
